import './index.scss';


class Twistcard extends HTMLElement {
  constructor() {
    super();

    const id = this.dataset.id;

    if (!id) return;

    for (const button of document.querySelectorAll(`[data-twistcard-show="${id}"]`)) {
      button.addEventListener('click', () => {
        this.removeAttribute('aria-hidden');
      });
    }

    for (const button of this.querySelectorAll('[data-twistcard-hide]')) {
      button.addEventListener('click', () => {
        this.setAttribute('aria-hidden', 'true');
      });
    }
  }
}

customElements.get('f-twistcard') || customElements.define('f-twistcard', Twistcard);
